export const ERROR_MESSAGES = {
  SignInRequired: 'Sign in required.',
  FormCannotBeLoaded: 'Form cannot be loaded.',
  FormAccessError: 'Access error.',
  SessionAlreadySubmittedError: 'Session has already been submitted.',
  SessionTerminatedError: 'Session has been terminated.',
  FormUnavailableError: 'Component is unavailable.',
};

class ErrorHandler {
  constructor(formComponent) {
    this.form = formComponent;
  }

  handleFormError = (e) => {
    try {
      if (!e.response) {
        this.form.props.history.push('/form_error');
        return;
      }

      if (e.response.status === 401) {
        this.form.setState({ form_oauth2: 'oauth2' });
        return;
      }

      let err = e.response.data;

      switch (err.msg) {
        case ERROR_MESSAGES.SignInRequired:
          this.form.setState({ form_oauth2: 'oauth2' });
          break;
        case ERROR_MESSAGES.FormAccessError:
          this.form.props.history.push('/form_error/access');
          break;
        case ERROR_MESSAGES.SessionAlreadySubmittedError:
          this.form.props.history.push('/form_error/already_submitted');
          break;
        case ERROR_MESSAGES.SessionTerminatedError:
          this.form.props.history.push('/form_error/terminated');
          break;
        case ERROR_MESSAGES.FormUnavailableError:
          this.form.props.history.push('/form_error/unavailable');
          break;
        case ERROR_MESSAGES.FormCannotBeLoaded:
        default:
          this.form.props.history.push('/form_error');
          break;
      }
    } catch (e) {
      this.form.props.history.push('/form_error');
    }
  };

  handleErrorState = (error) => {
    console.log(error);
    this.form.setState((state) => {
      return {
        processD: true,
        currentStep: 0,
        response: true,
        finished: true,
        sended: false,
        isSubmitting: false,
        pageProcessing: false,
      };
    });
  };

  closeAlert = () => {
    this.form.setState({ AlertD: false });
  };

  showAlert = (message, status = 200) => {
    this.form.setState({
      AlertD: true,
      AlertMsg: { message, status },
    });
  };

  handleValidationError = (requiredFields, requiredTableFields) => {
    this.form.setState({
      required_list: requiredFields || [],
      required_list_table: requiredTableFields || {},
    });
  };

  handlePageError = (errors) => {
    this.form.setState({
      pagesError: errors,
      pagesErrorDialog: true,
    });
  };

  handleFailedSubmission = (failures) => {
    this.form.setState({
      formFailures: failures,
      showFailedSubmissionDialog: true,
    });
  };

  clearErrors = () => {
    this.form.setState({
      AlertD: false,
      required_list: [],
      required_list_table: {},
      pagesError: [],
      pagesErrorDialog: false,
      formFailures: {},
      showFailedSubmissionDialog: false,
    });
  };

  logError = (error, context = '') => {
    console.error(`Error in ${context}:`, error);

    if (process.env.NODE_ENV === 'production') {
      // Send to error tracking service
    }
  };

  showUserError = (message) => {
    this.showAlert(message, 400);
  };

  showSuccess = (message) => {
    this.showAlert(message, 200);
  };

  handleNetworkError = (error) => {
    let message =
      'Network error occurred. Please check your connection and try again.';

    if (error.response) {
      if (error.response.status >= 500) {
        message = 'Server error occurred. Please try again later.';
      } else if (error.response.status === 401) {
        message = 'Authentication required. Please sign in again.';
        this.form.setState({ form_oauth2: 'oauth2' });
      } else if (error.response.status === 403) {
        message = "You don't have permission to perform this action.";
      } else if (error.response.status === 404) {
        message = 'The requested resource was not found.';
      }
    } else if (error.request) {
      message =
        'Unable to connect to server. Please check your internet connection.';
    }

    this.showUserError(message);
    this.logError(error, 'Network');
  };
}

export default ErrorHandler;
